{
  "header": {
    "title": "Fragenverlauf",
    "description": "Überprüfen und analysieren Sie frühere Feedback-Antworten"
  },
  "emptyState": {
    "company": {
      "title": "Noch keine Daten gesammelt",
      "description": "Deine Reise beginnt hier! Sobald Mitarbeiter im ersten Monat Feedback geben, wirst du Erkenntnisse und Trends sehen"
    },
    "directReports": {
      "title": "Keine direkten Mitarbeitenden",
      "description": "Du hast keine direkten Mitarbeitenden zugewiesen, aber du kannst trotzdem an Umfragen teilnehmen und wertvolles Feedback geben!",
      "bottomAction": {
        "label": "Wenn du denkst, dass das ein Fehler ist, kontaktiere deine Führungskraft",
        "helpText": "Hilfetext"
      }
    }
  },
  "NotEnoughResponse": {
    "title": "Noch nicht genug Antworten",
    "description": "Die Bewertung wird angezeigt, sobald mindestens 3 Antworten gesammelt wurden"
  },
  "tabs": {
    "company": "Gesamtes Unternehmen",
    "allReports": "Alle Berichte",
    "directReports": "Direkte Berichte",
    "myTeam": "Mein Team"
  },
  "leaderDropdown": {
    "triggerLabel": "Leiter",
    "searchPlaceholder": "Finde einen Leiter"
  },
  "categoryDropdown": {
    "triggerLabel": "Kategorien"
  },
  "table": {
    "columns": {
      "date": "Datum",
      "question": "Frage",
      "category": "Kategorie",
      "satisfactionScore": "Zufriedenheitsbewertung",
      "responses": "Antworten"
    }
  },
  "detailsPage": {
    "header": {
      "description": "Überprüfen und analysieren Sie frühere Feedback-Antworten",
      "exportButton": "Exportieren",
      "backButton": "Zurück zur Fragenhistorie"
    },
    "tabs": {
      "company": "Gesamtes Unternehmen",
      "allReports": "Alle Berichte",
      "directReports": "Direkte Berichte",
      "myTeam": "Mein Team"
    },
    "leaderDropdown": {
      "triggerLabel": "Leiter",
      "searchPlaceholder": "Einen Leiter finden"
    },
    "satisfactionScoreSection": {
      "title": "Zufriedenheitswert",
      "barChart": {
        "title": "Antwortverteilung",
        "agreeTitle": "Zustimmen",
        "somewhatAgreeTitle": "Eher zustimmen",
        "neutralTitle": "Neutral",
        "somewhatDisagreeTitle": "Eher nicht zustimmen",
        "disagreeTitle": "Nicht zustimmen"
      }
    },
    "directReportSection": {
      "title": "Team des direkten Berichts",
      "empty": {
        "title": "Keine direkt unterstellten Führungskräfte",
        "description": "Dieser Leader hat keine untergeordneten Führungskräfte, oder die Daten wurden noch nicht geladen."
      }
    },
    "participationRateSection": {
      "title": "Teilnahmerate"
    },
    "responsesCount_one": "{{count}} Antwort",
    "responsesCount_other": "{{count}} Antworten",
    "previousResponseSection": {
      "title": "Vorherige Antwort"
    },
    "enps": {
      "categoryName": "eNPS",
      "questionText": "Wie wahrscheinlich ist es, dass Sie die Arbeit in unserem Unternehmen empfehlen?",
      "scoreSection": {
        "title": "eNPS-Wert",
        "companyAverage": "Unternehmensdurchschnitt: {{score}}",
        "tooltip": {
          "description": "Der Employee Net Promoter Score (eNPS) wird berechnet, indem Mitarbeitende auf einer Skala von 0 bis 10 befragt werden:",
          "promoters": "Promotoren (9-10)",
          "passives": "Passive (7-8)",
          "detractors": "Kritiker (0-6)",
          "formulaLabel": "Die Formel lautet:",
          "formula": "% Promotoren - % Kritiker = eNPS",
          "resultRange": "Das Ergebnis reicht von -100 bis 100, wobei ein höherer Wert besser ist. Passive werden bei der finalen Berechnung ausgeschlossen."
        }
      },
      "distribution": {
        "title": "Antwortverteilung",
        "subtitle": "Anzahl der Antworten",
        "detractors": "Kritiker ({{percentage}}%)",
        "passives": "Passive ({{percentage}}%)",
        "promoters": "Promotoren ({{percentage}}%)",
        "xAxisLabel": "Antwortwert"
      },
      "trendSection": {
        "title": "eNPS im Zeitverlauf",
        "subtitle": "6-Monats-Aufschlüsselung",
        "yourTeam": "Ihr Team",
        "companyAverage": "Unternehmensdurchschnitt"
      },
      "directReportSection": {
        "title": "Team des direkten Berichts",
        "teamTitle": "Team von {{leaderName}}"
      },
      "previousResponseSection": {
        "title": "Vorherige Antwort",
        "columns": {
          "date": "Datum",
          "score": "eNPS-Wert",
          "responsePercentage": "Antwortprozentsatz"
        }
      }
    },
    "table": {
      "columns": {
        "date": "Datum",
        "question": "Zufriedenheitsbewertung",
        "responses": "Antwortprozentsatz"
      }
    }
  },
  "titleColumns": "Spalten",
  "showAllColumns": "Alle Spalten anzeigen",
  "hideAllColumns": "Alle Spalten ausblenden"
}
